const AGENT_QUERY_SESSION_ROUTES = new Set([
    '/fto-pro',
    '/novelty-check-report',
    '/design-fto',
]);

/**
 * 将外部提供的会话 ID 规范化为非空字符串。
 *
 * @param value 任意来源的会话 ID。
 * @returns 去除首尾空白后的会话 ID；无效值返回 undefined。
 */
export function normalizeRavenSessionId(value: unknown): string | undefined {
    if (typeof value !== 'string') return undefined;

    const sessionId = value.trim();
    return sessionId || undefined;
}

function createRouteUrl(href: string): URL | undefined {
    try {
        const currentUrl = new URL(href, 'http://raven.local');
        const route = currentUrl.hash.startsWith('#/')
            ? currentUrl.hash.slice(1)
            : `${currentUrl.pathname}${currentUrl.search}`;
        return new URL(route, 'http://raven.local');
    } catch {
        return undefined;
    }
}

function decodePathSessionId(value: string | undefined): string | undefined {
    if (!value) return undefined;

    try {
        return normalizeRavenSessionId(decodeURIComponent(value));
    } catch {
        return undefined;
    }
}

function resolveQuerySessionId(searchParams: URLSearchParams): string | undefined {
    const snakeCaseTaskId = normalizeRavenSessionId(searchParams.get('task_id'));
    if (snakeCaseTaskId) return snakeCaseTaskId;
    return normalizeRavenSessionId(searchParams.get('taskId'));
}

/**
 * 从 Eureka Agent 详情地址中解析会话 ID。
 *
 * FTO Pro、Novelty 和 Design FTO 使用任务 ID；Assistant 使用 chat 路径中的
 * conversation ID。仅识别已知 Agent 详情路由，避免影响其他带任务参数的页面。
 *
 * @param href 当前浏览器完整地址。
 * @returns 当前 Agent 会话 ID；无法识别时返回 undefined。
 */
export function resolveRavenSessionId(href: string): string | undefined {
    const routeUrl = createRouteUrl(href);
    if (!routeUrl) return undefined;

    const routePath = routeUrl.pathname.replace(/\/+$/, '') || '/';
    const assistantMatch = routePath.match(/^\/assistant\/chat\/([^/]+)(?:\/|$)/);
    if (assistantMatch) {
        return decodePathSessionId(assistantMatch[1]);
    }

    const designFtoPathMatch = routePath.match(/^\/design-fto\/([^/]+)$/);
    if (designFtoPathMatch) {
        return decodePathSessionId(designFtoPathMatch[1]);
    }

    if (!AGENT_QUERY_SESSION_ROUTES.has(routePath)) {
        return undefined;
    }

    return resolveQuerySessionId(routeUrl.searchParams);
}
